// Shared catalog helpers. The book DATA now lives in the database and is fetched
// via BooksContext; this file only holds pure helpers/constants.

const ASSOCIATES_TAG = "digsbyearlyle-20"; // Amazon Associates tag appended to all book links.

// RULE: every Amazon link MUST be built with amazonUrl(). It applies the current
// ASSOCIATES_TAG to any base URL and normalizes/overwrites existing tags/params.
export function amazonUrl(base) {
  if (!base) return base;
  try {
    const url = new URL(base);
    if (ASSOCIATES_TAG) url.searchParams.set("tag", ASSOCIATES_TAG);
    return url.toString();
  } catch {
    if (!ASSOCIATES_TAG) return base;
    const sep = base.includes("?") ? "&" : "?";
    return `${base}${sep}tag=${ASSOCIATES_TAG}`;
  }
}

export const CATEGORIES = {
  WORKBOOK: "Workbooks",
  STORY: "Story Books",
  EDUCATOR: "For Educators",
};

// Curated best-sellers for the Home carousel (falls back gracefully if a slug is missing).
export const featuredSlugs = [
  "alphabet",
  "mona-whoever-she-wants",
  "numbers",
  "miya-loves-spiders",
  "math-addition",
  "shaheem-and-neiko",
];

export const isComingSoon = (book) =>
  book && (book.status === "coming_soon" || book.comingSoon);
